import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../../contexts/AuthContext";
import { svg } from "../../resources/Svg";
import Alert from "../Alert";

const signinVariants = {
  hidden: {
    x: "-100vw",
    opacity: 0.1,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.3, delay: 0.2 },
  },
  exit: {
    x: "-100vw",
    transition: { ease: "easeInOut" },
  },
};

const Signin = ({ containerMinHeight }) => {
  const { signin, currentUser } = useAuth();
  const [info, setInfo] = useState({ email: "", password: "" });
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  if (currentUser !== null) return <Redirect to="/Dashboard" />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!info.email || !info.password)
      return setErrorMsg("All field are required");
    try {
      setErrorMsg("");
      setLoading(true);
      await signin(info.email, info.password);
      <Redirect to="/Dashboard" />;
      setInfo({ email: "", password: "" });
    } catch (error) {
      setErrorMsg(error.message);
    }
    setLoading(false);
  };

  return (
    <>
      <motion.main
        style={{ minHeight: `calc(100vh - ${containerMinHeight}px)` }}
        className="flex items-center justify-center pb-16 pt-10 px-4 sm:px-6 lg:px-8"
        variants={signinVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        <div className="max-w-md w-full space-y-8">
          {/*Logo and title*/}
          <div>
            <h2 className="mt-6 text-center text-3xl uppercase tracking-tight font-extrabold text-gray-800">
              Sign in to your account
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600 ">
              Or
              <Link
                to="/SignUp"
                className="font-medium text-indigo-600 hover:text-indigo-500 ml-1 capitalize"
              >
                Create Your free account
              </Link>
            </p>
          </div>
          {/*END Logo and title*/}

          <div className="bg-gray-50 border p-5 rounded-2xl shadow-lg">
            <form className="my-5 space-y-6" onSubmit={(e) => handleSubmit(e)}>
              <div className="space-y-6">
                {/*Email Section*/}
                <section className="flex flex-col mb-4">
                  <label
                    htmlFor="email"
                    className="mb-2 font-medium text-gray-800"
                  >
                    Email Address
                  </label>
                  <input
                    spellCheck="false"
                    autoComplete="email"
                    className=" shadow-sm py-2 px-3 rounded-md focus:ring-2 focus:ring-blue-600 focus:outline-none focus:border-0"
                    type="email"
                    name="email"
                    required
                    placeholder="Enter Email Here"
                    onChange={(e) =>
                      setInfo({ ...info, email: e.target.value })
                    }
                  />
                </section>

                <section className="flex flex-col mb-4">
                  <label
                    htmlFor="password"
                    className="mb-2 font-medium text-gray-800"
                  >
                    Password
                  </label>
                  <input
                    className="shadow-sm py-2 px-3 rounded-md focus:ring-2 focus:ring-blue-600 focus:outline-none"
                    type="password"
                    name="password"
                    required
                    placeholder="Enter Password Here"
                    onChange={(e) =>
                      setInfo({ ...info, password: e.target.value })
                    }
                  />
                </section>
              </div>

              <div className="flex items-center justify-center">
                <div className="text-sm">
                  <Link
                    to="/Fogot-Password"
                    className="font-medium text-indigo-600 hover:text-indigo-500"
                  >
                    Forgot your password?
                  </Link>
                </div>
              </div>
              {/*End forget password*/}

              {/*Button Sign in*/}
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                disabled={loading}
              >
                <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                  <svg
                    className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
                Sign in
              </button>
              {/*End Button Sign in*/}
            </form>
            {errorMsg && (
              <Alert
                svg={svg.danger}
                iconFlag={"red-500"}
                textFlag={"red-600"}
                text={errorMsg}
              />
            )}

            {/*Continue with*/}
            <section className="w-full flex justify-between items-center md:space-x-3 space-x-2 p-2">
              <div className="md:w-28 w-16 h-0.5 rounded-full bg-gray-300"></div>
              <div className="text-center text-gray-500">Or continue with</div>
              <div className="md:w-28 w-16 h-0.5 rounded-full bg-gray-300"></div>
            </section>
            {/*END Continue with*/}

            {/*Social media*/}
            <section className="mt-5 w-full flex items-center justify-evenly mb-5">
              <svg
                className="hover:bg-indigo-700 cursor-pointer fill-current text-white bg-indigo-600 rounded-md px-4 py-2 w-20 h-10"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M15.997 3.985h2.191V.169C17.81.117 16.51 0 14.996 0c-3.159 0-5.323 1.987-5.323 5.639V9H6.187v4.266h3.486V24h4.274V13.267h3.345l.531-4.266h-3.877V6.062c.001-1.233.333-2.077 2.051-2.077z" />
              </svg>

              <svg
                className="hover:bg-indigo-700 cursor-pointer fill-current text-white bg-indigo-600 rounded-md px-4 py-2 w-20 h-10"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path d="M512 97.248c-19.04 8.352-39.328 13.888-60.48 16.576 21.76-12.992 38.368-33.408 46.176-58.016-20.288 12.096-42.688 20.64-66.56 25.408C411.872 60.704 384.416 48 354.464 48c-58.112 0-104.896 47.168-104.896 104.992 0 8.32.704 16.32 2.432 23.936-87.264-4.256-164.48-46.08-216.352-109.792-9.056 15.712-14.368 33.696-14.368 53.056 0 36.352 18.72 68.576 46.624 87.232-16.864-.32-33.408-5.216-47.424-12.928v1.152c0 51.008 36.384 93.376 84.096 103.136-8.544 2.336-17.856 3.456-27.52 3.456-6.72 0-13.504-.384-19.872-1.792 13.6 41.568 52.192 72.128 98.08 73.12-35.712 27.936-81.056 44.768-130.144 44.768-8.608 0-16.864-.384-25.12-1.44C46.496 446.88 101.6 464 161.024 464c193.152 0 298.752-160 298.752-298.688 0-4.64-.16-9.12-.384-13.568 20.832-14.784 38.336-33.248 52.608-54.496z" />
              </svg>
              <svg
                className="hover:bg-indigo-700 cursor-pointer fill-current text-white bg-indigo-600 rounded-md px-4 py-2 w-20 h-10"
                viewBox="0 0 256 262"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
                  fill="#fff"
                />
                <path
                  d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
                  fill="#fff"
                />
                <path
                  d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
                  fill="#fff"
                />
                <path
                  d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
                  fill="#fff"
                />
              </svg>
            </section>
            {/*END Social media*/}
          </div>
        </div>
      </motion.main>
    </>
  );
};

export default Signin;
